import { Box, Button, Grid, Typography } from "@mui/material";
import React, { useEffect, useRef, useState } from "react";
import ExploreImage1 from "../../assets/svg/explore-image-1.svg";
import IACWhiteLogo from "../../assets/svg/iac-white-logo.svg";
import { benefits, features } from "./data";
import FeatureTile from "./featureTile";
import { useStyles } from "./styles";

const Explore = () => {
  const scrollContainerRef = useRef();
  const classes = useStyles();
  const featureCardLength = 900;
  const [width, setWidth] = useState([0, 0, 0, 0]);
  const [display, setDisplay] = useState(["block", "none", "none", "none"]);

  useEffect(() => {
    handleScroll();
  }, []);

  const handleScroll = () => {
    const childrenArray = scrollContainerRef.current?.children;
    const parentRect = scrollContainerRef.current.getBoundingClientRect();
    const childRect1 = childrenArray[0].getBoundingClientRect();
    const childRect2 = childrenArray[1].getBoundingClientRect();
    const childRect3 = childrenArray[2].getBoundingClientRect();
    const childRect4 = childrenArray[3].getBoundingClientRect();

    const width1 =
      childRect1.top <= parentRect.top
        ? featureCardLength - (parentRect.top - childRect1.top)
        : featureCardLength;
    const width2 =
      childRect2.top <= parentRect.top
        ? featureCardLength - (parentRect.top - childRect2.top)
        : childRect2.bottom >= parentRect.bottom
        ? featureCardLength - (childRect2.bottom - parentRect.bottom)
        : featureCardLength;
    const width3 =
      childRect3.top <= parentRect.top
        ? featureCardLength - (parentRect.top - childRect3.top)
        : childRect3.bottom >= parentRect.bottom
        ? featureCardLength - (childRect3.bottom - parentRect.bottom)
        : featureCardLength;
    const width4 =
      childRect4.top <= parentRect.top
        ? featureCardLength - (parentRect.top - childRect4.top)
        : childRect4.bottom >= parentRect.bottom
        ? featureCardLength - (childRect4.bottom - parentRect.bottom)
        : featureCardLength;

    const display1 = parentRect.top - childRect1.top > 200 ? "none" : "block";
    const display2 =
      parentRect.top - childRect2.top > 200 ||
      childRect2.bottom - parentRect.bottom > 200
        ? "none"
        : "block";
    const display3 =
      parentRect.top - childRect3.top > 200 ||
      childRect3.bottom - parentRect.bottom > 200
        ? "none"
        : "block";
    const display4 =
      parentRect.top - childRect4.top > 200 ||
      childRect4.bottom - parentRect.bottom > 200
        ? "none"
        : "block";

    setWidth([width1, width2, width3, width4]);
    setDisplay([display1, display2, display3, display4]);
  };

  useEffect(() => {
    scrollContainerRef.current?.addEventListener("scroll", handleScroll);

    return () => {
      // eslint-disable-next-line
      scrollContainerRef?.current?.removeEventListener("scroll", handleScroll);
    };
  }, []);

  return (
    <Box width={"100%"}>
      <Box
        sx={{ background: (theme) => theme.palette.blue[5] }}
        paddingY={2}
        paddingX={1}
        display={"flex"}
        alignItems={"center"}
      >
        <img src={IACWhiteLogo} alt="iac-logo" />
        <Typography ml={2} color={"white"}>
          Explore IAC
        </Typography>
      </Box>
      <Box className={classes?.section} padding={5}>
        <Grid container spacing={2}>
          <Grid
            sx={{ display: "flex", justifyContent: "center" }}
            md={6}
            xs={12}
          >
            <img src={ExploreImage1} alt="iac-explore-image" />
          </Grid>
          <Grid
            sx={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
            }}
            p={10}
            md={6}
            xs={12}
          >
            <Box color={"white"}>
              <Typography
                variant="h5"
                gutterBottom={true}
                fontWeight={600}
                mb={2}
              >
                Infrastructure as Code Controller
              </Typography>
              <Typography fontSize={18}>
                IAC Controller automates creating and managing new AWS accounts
                with security configurations and also bring your existing
                infrastructure under IaC management using Terraform. This will
                give you more control and easier management of your AWS
                resources.
              </Typography>
            </Box>
          </Grid>
        </Grid>
      </Box>
      <Box p={3}>
        <Typography
          sx={{ color: (theme) => theme.palette.purple[1] }}
          variant="h5"
          fontWeight={600}
          mb={2}
          gutterBottom={true}
        >
          Benefits
        </Typography>
        <Grid container>
          {benefits.map((benefit) => (
            <Grid display={"flex"} md={2} xs={12} mr={3}>
              <Box display={"flex"}>
                <Box
                  sx={{ background: (theme) => theme.palette.blue[3] }}
                  width={7}
                  height={"60%"}
                  borderRadius={1}
                />
                <Box
                  mt={3}
                  ml={"-4px"}
                  bgcolor={"#4E37994D"}
                  width={7}
                  height={"60%"}
                  borderRadius={1}
                />
              </Box>
              <Typography p={1} fontSize={20}>
                {benefit}
              </Typography>
            </Grid>
          ))}
        </Grid>
      </Box>
      <Box
        position="relative"
        display="flex"
        justifyContent="center"
        alignItems="center"
      >
        <Button
          variant="outlined"
          sx={{
            position: "absolute",
            width: "auto",
            color: (theme) => theme.palette.blue[5],
            backgroundColor: (theme) => theme.palette.common.white,
            border: (theme) => `2px solid ${theme.palette.blue[5]}`,
            cursor: "unset",
            ":hover": {
              border: (theme) => `2px solid ${theme.palette.blue[5]}`,
              backgroundColor: (theme) => theme.palette.common.white,
            },
          }}
        >
          <Typography variant="h5">What we do!</Typography>
        </Button>
      </Box>
      <Box sx={{ background: (theme) => theme.palette.blue[5] }}>
        <Box
          sx={{
            "::-webkit-scrollbar": {
              display: "none",
            },
          }}
          ref={scrollContainerRef}
          py={5}
          height={500}
          overflow={"scroll"}
        >
          {features.map((feature) => (
            <FeatureTile
              feature={feature}
              width={width[feature?.id - 1]}
              color={feature?.color}
              display={display[feature?.id - 1]}
            />
          ))}
        </Box>
      </Box>
      <Box className={classes.footerView}>
        <Typography>
          This Dashboard content provides a high-level overview of your IaC
          strategy for managing your AWS infrastructure. It highlights the
          benefits of automation and centralized control for improved efficiency
          and reduced risk
        </Typography>
      </Box>
    </Box>
  );
};

export default Explore;
